$(document).ready(function() {



    var $slider = $(".main_slider");

    $slider.slick({
        autoplay: true,
        autoplaySpeed: 5000,
        slidesToShow: 1,
        arrows: true,
        slidesToScroll: 1,
        // dots: true,
        infinite: true,
        speed: 500,
        fade: true,
        cssEase: 'linear'

       
    });
    updateCounter();
    var $prevButton = $('#banner_prev');
    var $nextButton = $('#banner_next');
    var totalSlides = $('.main_slider').slick('getSlick').slideCount;
    var perSlideline = 100 / totalSlides
    var totalSlides = $('.main_slider').slick('getSlick').slideCount;

    var countallWidth = `calc(100% / ${totalSlides.toString().padStart(2, '0')})`;

    $('span.countall').css('width', countallWidth);
    $nextButton.click(function() {
        $slider.slick('slickNext');
        var currentSlide = $('.main_slider').slick('slickCurrentSlide') + 1;
        var full_width = perSlideline * currentSlide;
        $('span.countall').css('width', full_width+'%');
       
    });

    $prevButton.click(function() {
        $slider.slick('slickPrev');
        var currentSlide = $('.main_slider').slick('slickCurrentSlide') + 1;
        var full_width = perSlideline * currentSlide;
        $('span.countall').css('width', full_width+'%');
        console.log(currentSlide)
    });

    $('.main_slider').on('afterChange', function(event, slick, currentSlide, nextSlide){
        updateCounter();
      });
  
      function updateCounter() {
 
      
        var currentSlide = $('.main_slider').slick('slickCurrentSlide') + 1;

      
        var totalSlides = $('.main_slider').slick('getSlick').slideCount;
        console.log("ito",totalSlides.toString().padStart(totalSlides, '0'))
        $('.slider_count .active_count').text('0'+currentSlide.toString());

        $('.slider_count .not_active').text('/0'+totalSlides.toString());
      }

    
});